export const MAINTENANCE_CONFIG = {
  global: false,
  reportExtract: false,
  reportStandardizer: false,
  prescriptions: false,
  integrations: false,
  importCenter: false,
};

export function isUnderMaintenance(path) {
  if (path === "/report-extract") return MAINTENANCE_CONFIG.reportExtract;
  if (path === "/report-standardizer") return MAINTENANCE_CONFIG.reportStandardizer;
  if (path === "/prescriptions") return MAINTENANCE_CONFIG.prescriptions;
  if (path === "/integrations") return MAINTENANCE_CONFIG.integrations;
  if (path === "/imports") return MAINTENANCE_CONFIG.importCenter;
  return false;
}
